





























































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import GroupsBookingDetails from "./GroupsBookingDetails.vue";

import UserJson from "../../shared/UserJson";
import GroupBookingJson from "../../shared/GroupBookingJson";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { GroupBookingStatus } from "../../shared/GroupBookingStatus";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "GroupsPayments",
  components: {
    Loading,
    GroupsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
    GroupsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      GroupBookingStatus: GroupBookingStatus,
      paymentExportGroups: null as GroupBookingJson[] | null,
      exportedGroups: null as PaymentExportInfoJson[] | null,
      selectedBookingId: null as number | null,
      detailsMode: "read",
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: GroupBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedBookingId = item.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadGroupsToExport();
      this.loadExportedGroups();
    },

    async loadGroupsToExport() {
      this.paymentExportGroups = null;
      if (this.restClient != null) {
        try {
          this.paymentExportGroups = await this.restClient.getGroupBookingsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedGroups() {
      this.exportedGroups = null;
      if (this.restClient != null) {
        try {
          this.exportedGroups = await this.restClient.getRecentPaymentExports(PaymentExportType.groupBookings);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //export payment data
    async exportPaymentData() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForGroupBookings();
        if (exportInfo != null) {
          this.downloadPaymentData(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadPaymentData(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
